// Vocabularies for the Parish Profile "Music Resources" tab (Phase 2).
// This is ADDITIVE to the existing worship_music tab and does not
// replace it. It captures catalog-aware fields the Musical
// Intelligence retrieval engine reads: preferred / excluded resources,
// choir voicing, instruments, difficulty, style, languages, songs to
// avoid, seasonal customs, and special local practices.

export const MUSIC_RESOURCES_FIELDS = [
  {
    section: "Tradition & Rite",
    fields: [
      { key: "tradition", label: "Tradition", type: "select", options_key: "traditions" },
      { key: "rite", label: "Rite / Order of Service", type: "select", options_key: "rites" },
    ],
  },
  {
    section: "Catalog & Resources",
    fields: [
      { key: "hymnals_owned", label: "Hymnals Owned", type: "resource_multi",
        help: "The catalog resources your parish owns. Recommendations preferentially draw from these." },
      { key: "supplemental_resources", label: "Supplemental Resources", type: "resource_multi",
        help: "Additional resources you own but don't rely on weekly." },
      { key: "licensed_publishers", label: "Licensed Publishers / Platforms", type: "chips",
        options: ["OneLicense", "CCLI", "CCS", "GIA License", "OCP License",
                  "Church Copyright Coalition", "PraiseCharts", "Planning Center Library"] },
      { key: "preferred_resources", label: "Preferred Resources", type: "resource_multi",
        help: "Resources the recommendation engine should prioritize." },
      { key: "excluded_resources", label: "Excluded Resources", type: "resource_multi",
        help: "Resources the recommendation engine should never draw from." },
    ],
  },
  {
    section: "Ensemble Capacity",
    fields: [
      { key: "choir_voicing", label: "Choir Voicing", type: "chips", options_key: "choir_voicings" },
      { key: "available_instruments", label: "Available Instruments", type: "chips", options_key: "instruments" },
      { key: "congregational_difficulty", label: "Congregational Difficulty (typical)", type: "select",
        options_key: "congregational_difficulty" },
    ],
  },
  {
    section: "Musical Voice",
    fields: [
      { key: "preferred_styles", label: "Preferred Musical Styles", type: "chips", options_key: "musical_styles" },
      { key: "languages", label: "Languages Sung", type: "chips", options_key: "languages" },
      { key: "songs_to_avoid", label: "Songs or Works to Avoid", type: "textarea",
        placeholder: "One per line. e.g. Onward, Christian Soldiers" },
    ],
  },
  {
    section: "Seasonal & Local",
    fields: [
      { key: "seasonal_customs", label: "Seasonal Parish Customs", type: "seasonal",
        seasons_key: "liturgical_seasons",
        placeholder: "e.g. Great Litany on Advent 1; O Antiphons Dec 17–23" },
      { key: "special_local_practices", label: "Special Local Practices", type: "textarea",
        placeholder: "Any parish-specific customs your musicians observe — patronal customs, memorial practices, community rites, etc." },
    ],
  },
];
